module.exports = __webpack_public_path__ + "img/competition-logo.b99173c0.svg";